<template>
  <div v-if="dadosVeiculo" class="marginOutside wrapperPage">
    <div class="bg-header header cabecalhoPdf">
      <div>
        <p class="uppercase font-black text-base md:text-3xl text-nowrap">
          CERTIFICADO DE SEGURO
        </p>
      </div>
      <div class="logo text-center">
        <img
          src="https://bboneapp.s3.amazonaws.com/logo-bpseguradora-v2.svg"
          class="w-24 md:w-48"
        />
      </div>
    </div>
    <div class="bodyGeral container relative content page">
      <div class="printBackground" />

      <div class="flex flex-col gap-4 mx-4 mt-4 md:mx-0">
        <vx-card class="mt-0">
          <div class="flex flex-col w-full">
            <div class="flex w-full title justify-center">
              <p>DADOS DA APÓLICE</p>
            </div>
            <div class="flex flex-col gap-3 pt-4">
              <div class="cell w-full" v-if="dadosVeiculo.nomeGrupo">
                <span>Produto:</span>
                <p>{{ dadosVeiculo.nomeGrupo }}</p>
              </div>

              <div class="flex flex-col md:flex-row w-full gap-2">
                <div
                  class="cell w-full md:w-1/3"
                  v-if="dadosVeiculo.id_proposta"
                >
                  <span>N° Proposta BPTECH:</span>
                  <p>{{ dadosVeiculo.id_proposta }}</p>
                </div>
                <div
                  class="cell w-full"
                  :class="{
                    'md:w-2/3': dadosVeiculo.id_proposta,
                    'w-full': !dadosVeiculo.id_proposta,
                  }"
                >
                  <span>N° Apólice:</span>
                  <p>{{ numeroApolice }}</p>
                </div>
              </div>

              <div class="flex flex-col md:flex-row w-full gap-2">
                <div class="cell w-full md:w-1/5 md:order-last">
                  <span>N° Endosso:</span>
                  <p>0</p>
                </div>
                <div class="cell w-full md:w-2/5">
                  <span>N° Certificado:</span>
                  <p>{{ numeroCertificado }}</p>
                </div>
                <div class="cell w-full md:w-2/5">
                  <span>Início da Vigência:</span>
                  <p>
                    {{ dadosVeiculo.initialValidity }}
                  </p>
                </div>
                <div class="cell w-full md:w-2/5">
                  <span>Término da Vigência:</span>
                  <p>
                    {{ dadosVeiculo.finalValidity }}
                  </p>
                </div>
              </div>

              <div class="flex flex-col md:flex-row w-full gap-2">
                <div class="cell w-full md:w-1/3">
                  <span>Seguradora:</span>
                  <p>{{ dadosVeiculo.nomeSeguradoraApolice }}</p>
                </div>
                <div class="cell w-full md:w-1/3">
                  <span>Cód. SUSEP:</span>
                  <p>{{ dadosVeiculo.codSusep }}</p>
                </div>
                <div class="cell w-full md:w-1/3">
                  <span>CNPJ:</span>
                  <p>{{ dadosVeiculo.cnpjApolice }}</p>
                </div>
              </div>

              <div class="flex flex-col md:flex-row w-full gap-2">
                <div class="cell w-full md:w-2/3">
                  <span>Endereço Seguradora:</span>
                  <p>{{ getEnderecoSeguradoraParte('endereco') }}</p>
                </div>
                <div class="flex flex-col md:flex-row gap-2 w-full md:w-1/3">
                  <div class="cell w-full md:w-1/3">
                    <span>N°:</span>
                    <p>{{ getEnderecoSeguradoraParte('numero') }}</p>
                  </div>
                  <div class="cell w-full md:w-2/3">
                    <span>Telefone:</span>
                    <p>{{ dadosVeiculo.telefoneApolice }}</p>
                  </div>
                </div>
              </div>

              <div class="flex flex-col md:flex-row w-full gap-2">
                <div class="cell w-full md:w-5/12">
                  <span>Bairro:</span>
                  <p>{{ getEnderecoSeguradoraParte('bairro') }}</p>
                </div>
                <div class="cell w-full md:w-3/12">
                  <span>Cidade:</span>
                  <p>{{ getEnderecoSeguradoraParte('cidade') }}</p>
                </div>
                <div class="cell w-full md:w-3/12">
                  <span>CEP:</span>
                  <p>{{ getEnderecoSeguradoraParte('cep') }}</p>
                </div>
                <div class="cell w-full md:w-1/12">
                  <span>UF:</span>
                  <p>{{ getEnderecoSeguradoraParte('estado') }}</p>
                </div>
              </div>
            </div>
          </div>
        </vx-card>

        <vx-card class="mt-0">
          <div class="flex flex-col w-full">
            <div class="flex w-full title justify-center">
              <p>DADOS DO SEGURADO</p>
            </div>
            <div class="flex flex-col gap-3 pt-4">
              <div class="flex flex-col md:flex-row w-full gap-2">
                <div class="cell w-full md:w-2/3">
                  <span>Nome/Social:</span>
                  <p>{{ dadosVeiculo.nome }}</p>
                </div>
                <div class="cell w-full md:w-1/3">
                  <span>CPF/CNPJ:</span>
                  <p>{{ dadosVeiculo.cpfcnpj }}</p>
                </div>
              </div>

              <div class="flex flex-col md:flex-row w-full gap-2">
                <div class="cell w-full md:w-3/5">
                  <span>Endereço:</span>
                  <p>{{ dadosVeiculo.endereco }}</p>
                </div>
                <div class="flex flex-col md:flex-row gap-2 w-full md:w-2/5">
                  <div class="cell w-full md:w-1/3">
                    <span>N°:</span>
                    <p>{{ dadosVeiculo.numero }}</p>
                  </div>
                  <div class="cell w-full md:w-2/3">
                    <span>Telefone:</span>
                    <p>{{ dadosVeiculo.celular }}</p>
                  </div>
                </div>
              </div>

              <div class="flex flex-col md:flex-row w-full gap-2">
                <div class="flex flex-col md:flex-row gap-2 w-full md:w-2/3">
                  <div class="cell w-full md:w-3/5">
                    <span>Bairro:</span>
                    <p>{{ dadosVeiculo.bairro }}</p>
                  </div>
                  <div class="cell w-full md:w-2/5">
                    <span>Cidade:</span>
                    <p>{{ dadosVeiculo.cidade }}</p>
                  </div>
                </div>
                <div class="flex flex-col md:flex-row gap-2 w-full md:w-1/3">
                  <div class="cell w-full md:w-3/4">
                    <span>CEP:</span>
                    <p>{{ dadosVeiculo.cep }}</p>
                  </div>
                  <div class="cell w-full md:w-1/4">
                    <span>UF:</span>
                    <p>{{ dadosVeiculo.estado }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </vx-card>

        <vx-card class="mt-0">
          <div class="flex flex-col w-full">
            <div class="flex w-full title justify-center">
              <p>DADOS DA CORRETORA</p>
            </div>
            <div class="flex flex-col gap-3 pt-4">
              <div class="flex flex-col md:flex-row w-full gap-2">
                <div class="cell w-full">
                  <span>Corretora:</span>
                  <p>{{ dadosVeiculo.corretora }}</p>
                </div>
              </div>

              <div class="flex flex-col md:flex-row w-full gap-2">
                <div class="cell w-full md:w-7/12">
                  <span>CPF/CNPJ:</span>
                  <p>{{ dadosVeiculo.cnpjCorretora }}</p>
                </div>
                <div class="flex gap-2 w-full md:w-5/12">
                  <div class="cell w-full">
                    <span>Código Susep:</span>
                    <p>{{ dadosVeiculo.codSusepCorretora }}</p>
                  </div>
                </div>
              </div>
              <div class="flex flex-col md:flex-row w-full gap-2">
                <div class="cell w-full md:w-1/3">
                  <span>Telefone:</span>
                  <p>{{ dadosVeiculo.telefoneCorretora }}</p>
                </div>
                <div class="cell w-full md:w-2/3">
                  <span>E-mail:</span>
                  <p>{{ dadosVeiculo.emailCorretora }}</p>
                </div>
              </div>
              <div class="flex flex-col md:flex-row w-full gap-2">
                <div class="cell w-full md:w-5/12">
                  <span>Endereço:</span>
                  <p>{{ getEnderecoCorretoraParte('endereco') }}</p>
                </div>
                <div class="cell w-full md:w-1/6">
                  <span>N°:</span>
                  <p>{{ getEnderecoCorretoraParte('numero') }}</p>
                </div>
                <div class="cell w-full md:w-5/12">
                  <span>Complemento:</span>
                  <p>{{ getEnderecoCorretoraParte('complemento') }}</p>
                </div>
              </div>

              <div class="flex flex-col md:flex-row w-full gap-2">
                <div class="cell w-full md:w-5/12">
                  <span>Bairro:</span>
                  <p>{{ getEnderecoCorretoraParte('bairro') }}</p>
                </div>
                <div class="cell w-full md:w-3/12">
                  <span>Cidade:</span>
                  <p>{{ getEnderecoCorretoraParte('cidade') }}</p>
                </div>
                <div class="cell w-full md:w-3/12">
                  <span>CEP:</span>
                  <p>{{ getEnderecoCorretoraParte('cep') }}</p>
                </div>
                <div class="cell w-full md:w-1/12">
                  <span>UF:</span>
                  <p>{{ getEnderecoCorretoraParte('estado') }}</p>
                </div>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>

    <div class="bodyGeral container relative content page">
      <div class="printBackground" />
      <div class="flex flex-col gap-4 mx-4 mt-4 md:mx-0">
        <vx-card class="mt-0">
          <div class="flex flex-col w-full">
            <div class="flex w-full title justify-center">
              <p>DADOS DO VEÍCULO</p>
            </div>
            <div class="flex flex-col gap-3 pt-4">
              <div class="flex flex-col md:flex-row w-full gap-2">
                <div class="cell w-full md:w-2/12">
                  <span>Placa:</span>
                  <p>{{ dadosVeiculo.placa }}</p>
                </div>
                <div class="cell w-full md:w-7/12">
                  <span>Marca/Modelo:</span>
                  <p>{{ dadosVeiculo.veiculoModelo }}</p>
                </div>
                <div class="cell w-full md:w-3/12">
                  <span>Cód Fipe:</span>
                  <p>{{ dadosVeiculo.codigoFipe }}</p>
                </div>
              </div>

              <div class="flex flex-col md:flex-row w-full gap-2">
                <div class="cell w-full md:w-3/12">
                  <span>Chassi:</span>
                  <p class="uppercase">{{ dadosVeiculo.chassi }}</p>
                </div>
                <div class="cell w-full md:w-3/12">
                  <span>Cor:</span>
                  <p>{{ dadosVeiculo.cor }}</p>
                </div>
                <div class="cell w-full md:w-3/12">
                  <span>Ano Fab./Ano Modelo:</span>
                  <p
                    v-if="dadosVeiculo.AnoFabricacao || dadosVeiculo.AnoModelo"
                  >
                    {{ dadosVeiculo.AnoFabricacao }}/{{
                      dadosVeiculo.AnoModelo
                    }}
                  </p>
                </div>
                <div class="cell w-full md:w-3/12">
                  <span>Combustível:</span>
                  <p>{{ dadosVeiculo.combustivel }}</p>
                </div>
              </div>
              <div
                class="flex w-full gap-2"
                v-if="
                  dadosVeiculo.acessorios &&
                  JSON.parse(dadosVeiculo.acessorios).length
                "
              >
                <div
                  class="flex w-full gap-2"
                  v-for="acessorio in JSON.parse(dadosVeiculo.acessorios)"
                  :key="acessorio.idComplemento"
                >
                  <div class="cell w-3/12">
                    <span>ACESSÓRIO:</span>
                    <p>
                      {{ acessorio.descricao }}
                    </p>
                  </div>
                  <div class="cell w-3/12">
                    <span>MARCA:</span>
                    <p>
                      {{ acessorio.marca }}
                    </p>
                  </div>
                  <div class="cell w-3/12">
                    <span>MODELO:</span>
                    <p>
                      {{ acessorio.modelo }}
                    </p>
                  </div>
                  <div class="cell w-3/12">
                    <span>VALOR MERCADO:</span>
                    <p>
                      {{ 'R$ ' + formatarMoeda(acessorio.valorCobertura) }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="flex flex-col md:flex-row w-full gap-2" v-else>
                <div class="cell w-full">
                  <span>Acessórios:</span>
                  <p class="uppercase">Não possui</p>
                </div>
              </div>
            </div>
          </div>
        </vx-card>

        <vx-card
          class="mt-0"
          v-if="
            dadosVeiculo.condutores &&
            JSON.parse(dadosVeiculo.condutores).length
          "
        >
          <div class="flex flex-col w-full">
            <div class="flex w-full title justify-center">
              <p>DADOS DO CONDUTOR</p>
            </div>
            <div
              class="flex flex-col gap-3 pt-4"
              v-for="condutor in JSON.parse(dadosVeiculo.condutores)"
              :key="condutor.cpfCondutor"
            >
              <div class="flex flex-col md:flex-row w-full gap-2">
                <div class="cell w-full">
                  <span>Nome:</span>
                  <p>{{ condutor.nomeCondutor }}</p>
                </div>
                <div class="cell w-full">
                  <span>CPF:</span>
                  <p>{{ condutor.cpfCondutor }}</p>
                </div>
              </div>
            </div>
          </div>
        </vx-card>

        <!-- COBERTURAS CONTRATADAS DESKTOP -->
        <vx-card class="mt-2 hidden md:block">
          <div class="flex flex-col w-full">
            <div class="flex w-full title justify-center">
              <p>COBERTURAS CONTRATADAS</p>
            </div>
            <div class="flex w-full gap-2 mt-4">
              <div class="w-5/12 subtitle">
                <p class="text-left pl-4">DESCRIÇÃO</p>
              </div>
              <div class="w-3/12 subtitle">
                <p>LMI - R$</p>
              </div>
              <div class="w-2/12 subtitle">
                <p>Franquia</p>
              </div>
              <div class="w-2/12 subtitle">
                <p>Prêmio Mensal</p>
              </div>
            </div>
            <div class="flex flex-col gap-3 pt-4">
              <div
                v-for="produto in dadosVeiculo.produtos.filter(
                  (produto) => produto.nomeProdutoResumo === 'Mensalidade',
                )"
                :key="produto.id_produto"
                class="flex w-full gap-2"
              >
                <div class="cell w-5/12 uppercase">
                  <p>Casco</p>
                </div>
                <div class="cell w-3/12">
                  <span>R$:</span>
                  <p>
                    {{
                      !hasProduct4021or5210(dadosVeiculo) &&
                      dadosVeiculo.codTipoVeiculo === codTipoVeiculoMotos
                        ? '70% tabela referenciada'
                        : '100% tabela referenciada'
                    }}
                  </p>
                </div>
                <div class="cell w-2/12">
                  <p class="uppercase">
                    {{ dadosVeiculo.valorCotaParticipacao }}% ou mínimo de
                    {{ formatarMoeda(dadosVeiculo.valorParticipacaoMinimo) }}
                  </p>
                </div>
                <div class="cell w-2/12">
                  <span>R$:</span>
                  <p>{{ somaValorProdutoMensal() }}</p>
                </div>
              </div>

              <div
                v-if="
                  !dadosVeiculo.nomeRegional.startsWith('COOPMETRO') && temAPP()
                "
              >
                <div
                  v-for="produto in filteredProductsApp"
                  class="flex w-full gap-2"
                  :key="produto.id_produto"
                >
                  <div class="cell w-5/12 uppercase">
                    <p>{{ produto.nomeProdutoResumo }}</p>
                  </div>
                  <div class="cell w-3/12">
                    <span>R$:</span>
                    <p>{{ extractValor(produto.nomeProduto) }}</p>
                  </div>
                  <div class="cell w-2/12">
                    <span>R$:</span>
                    <p>-</p>
                  </div>
                  <div class="cell w-2/12">
                    <span>R$:</span>
                    <p>-</p>
                  </div>
                </div>
              </div>

              <div
                v-for="produto in filteredProdutos"
                :key="produto.id_produto"
                class="flex w-full gap-2"
              >
                <div class="cell w-5/12 uppercase">
                  <p>{{ formatarNomeRCF(produto.nomeProdutoResumo) }}</p>
                </div>
                <div class="cell w-3/12">
                  <span>R$:</span>
                  <p>
                    {{
                      isRcfAndCoopemetro(produto.nomeProduto)
                        ? '-'
                        : extractValor(produto.nomeProduto)
                    }}
                  </p>
                </div>
                <div class="cell w-2/12">
                  <span>R$:</span>
                  <p>-</p>
                </div>
                <div class="cell w-2/12">
                  <span>R$:</span>
                  <p>-</p>
                </div>
              </div>

              <div
                class="flex w-full gap-2"
                v-if="
                  dadosVeiculo.acessorios &&
                  JSON.parse(dadosVeiculo.acessorios).length
                "
              >
                <div
                  class="flex w-full gap-2"
                  v-for="acessorio in JSON.parse(dadosVeiculo.acessorios)"
                  :key="acessorio.idComplemento"
                >
                  <div class="cell w-5/12">
                    <p>
                      {{ 'ACESSÓRIO - ' + acessorio.descricao }}
                    </p>
                  </div>
                  <div class="cell w-3/12">
                    <span>R$:</span>
                    <p>
                      {{ formatarMoeda(acessorio.valorCobertura) }}
                    </p>
                  </div>
                  <div class="cell w-2/12">
                    <p>10%</p>
                  </div>
                  <div class="cell w-2/12">
                    <span>R$:</span>
                    <p>-</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </vx-card>

        <!-- COBERTURAS CONTRATADAS MOBILE -->
        <vx-card class="mt-2 md:hidden">
          <div class="flex flex-col w-full">
            <div class="flex w-full title justify-center">
              <p>COBERTURAS CONTRATADAS</p>
            </div>

            <div class="flex flex-col gap-3 pt-4">
              <div
                v-for="produto in dadosVeiculo.produtos.filter(
                  (produto) => produto.nomeProdutoResumo === 'Mensalidade',
                )"
                :key="produto.id_produto"
                class="flex flex-col md:flex-row w-full gap-1"
              >
                <div class="flex flex-col w-full gap-2 mt-4">
                  <div class="w-full subtitle">
                    <p class="text-center pl-4">DESCRIÇÃO</p>
                  </div>
                  <div class="cell w-full uppercase">
                    <p>Casco</p>
                  </div>
                </div>

                <div class="flex flex-col w-full gap-2 mt-4">
                  <div class="w-full subtitle">
                    <p>LMI - R$</p>
                  </div>
                  <div class="cell w-full">
                    <p>
                      {{
                        !hasProduct4021or5210(dadosVeiculo) &&
                        dadosVeiculo.codTipoVeiculo === codTipoVeiculoMotos
                          ? '70% tabela referenciada'
                          : '100% tabela referenciada'
                      }}
                    </p>
                  </div>
                </div>

                <div class="flex flex-col w-full gap-2 mt-4">
                  <div class="w-full subtitle">
                    <p>Franquia</p>
                  </div>
                  <div class="cell w-full">
                    <p class="uppercase">
                      {{ dadosVeiculo.valorCotaParticipacao }}% ou mínimo de
                      {{ formatarMoeda(dadosVeiculo.valorParticipacaoMinimo) }}
                    </p>
                  </div>
                </div>

                <div class="flex flex-col w-full gap-2 mt-2">
                  <div class="w-full subtitle">
                    <p>Prêmio Mensal</p>
                  </div>
                  <div class="cell w-full">
                    <p>R$ {{ somaValorProdutoMensal() }}</p>
                  </div>
                </div>
                <div class="linha-divisor mt-6" />
              </div>
              <!-- Fim do for de mensalidade mobile -->

              <div
                v-if="
                  !dadosVeiculo.nomeRegional.startsWith('COOPMETRO') && temAPP()
                "
              >
                <div
                  v-for="produto in filteredProductsApp"
                  class="flex flex-col w-full gap-2"
                  :key="produto.id_produto"
                >
                  <div class="flex flex-col w-full gap-2 mt-4">
                    <div class="w-full subtitle">
                      <p class="text-center pl-4">DESCRIÇÃO</p>
                    </div>
                    <div class="cell w-full uppercase">
                      <p>{{ produto.nomeProdutoResumo }}</p>
                    </div>
                  </div>
                  <div class="flex flex-col w-full gap-2 mt-4">
                    <div class="w-full subtitle">
                      <p>LMI - R$</p>
                    </div>
                    <div class="cell w-full">
                      <span>R$:</span>
                      <p>{{ extractValor(produto.nomeProduto) }}</p>
                    </div>
                  </div>
                  <div class="flex flex-col w-full gap-2 mt-4">
                    <div class="w-full subtitle">
                      <p>Franquia</p>
                    </div>
                    <div class="cell w-full">
                      <span>R$:</span>
                      <p>-</p>
                    </div>
                  </div>
                  <div class="flex flex-col w-full gap-2 mt-2">
                    <div class="w-full subtitle">
                      <p>Prêmio Mensal</p>
                    </div>
                    <div class="cell w-2/12">
                      <span>R$:</span>
                      <p>-</p>
                    </div>
                  </div>
                </div>
                <div class="linha-divisor mt-6" />
              </div>

              <div
                v-for="produto in filteredProdutos"
                :key="produto.id_produto"
                class="flex flex-col w-full gap-2"
              >
                <div class="flex flex-col w-full gap-2 mt-4">
                  <div class="w-full subtitle">
                    <p class="text-center pl-4">DESCRIÇÃO</p>
                  </div>
                  <div class="cell w-full uppercase">
                    <p>{{ formatarNomeRCF(produto.nomeProdutoResumo) }}</p>
                  </div>
                </div>
                <div class="flex flex-col w-full gap-2 mt-4">
                  <div class="w-full subtitle">
                    <p>LMI - R$</p>
                  </div>
                  <div class="cell w-full">
                    <p>
                      {{
                        isRcfAndCoopemetro(produto.nomeProduto)
                          ? '-'
                          : extractValor(produto.nomeProduto)
                      }}
                    </p>
                  </div>
                </div>
                <div class="flex flex-col w-full gap-2 mt-4">
                  <div class="w-full subtitle">
                    <p>Franquia</p>
                  </div>
                  <div class="cell w-full">
                    <p>-</p>
                  </div>
                </div>
                <div class="flex flex-col w-full gap-2 mt-2">
                  <div class="w-full subtitle">
                    <p>Prêmio Mensal</p>
                  </div>
                  <div class="cell w-full">
                    <p>-</p>
                  </div>
                </div>
                <div class="linha-divisor mt-6" />
              </div>

              <div
                class="flex w-full gap-2"
                v-if="
                  dadosVeiculo.acessorios &&
                  JSON.parse(dadosVeiculo.acessorios).length
                "
              >
                <div
                  class="flex w-full gap-2"
                  v-for="acessorio in JSON.parse(dadosVeiculo.acessorios)"
                  :key="acessorio.idComplemento"
                >
                  <div class="flex flex-col w-full gap-2 mt-4">
                    <div class="w-full subtitle">
                      <p class="text-center pl-4">DESCRIÇÃO</p>
                    </div>
                    <div class="cell w-full uppercase">
                      <p>
                        {{ 'ACESSÓRIO - ' + acessorio.descricao }}
                      </p>
                    </div>
                  </div>
                  <div class="flex flex-col w-full gap-2 mt-4">
                    <div class="w-full subtitle">
                      <p>LMI - R$</p>
                    </div>
                    <div class="cell w-full">
                      <p>R$ {{ formatarMoeda(acessorio.valorCobertura) }}</p>
                    </div>
                  </div>
                  <div class="flex flex-col w-full gap-2 mt-4">
                    <div class="w-full subtitle">
                      <p>Franquia</p>
                    </div>
                    <div class="cell w-full">
                      <p>10%</p>
                    </div>
                  </div>
                  <div class="flex flex-col w-full gap-2 mt-2">
                    <div class="w-full subtitle">
                      <p>Prêmio Mensal</p>
                    </div>
                    <div class="cell w-full">
                      <p>-</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </vx-card>

        <!-- SERVICOS CONTRATADOS DESKTOP -->
        <vx-card class="mt-2 hidden md:block" v-if="servicos.length > 0">
          <div class="flex flex-col w-full">
            <div class="flex w-full title justify-center">
              <p>SERVIÇOS CONTRATADOS</p>
            </div>
            <div class="flex w-full gap-2 mt-4">
              <div class="w-5/12 subtitle">
                <p class="text-left pl-4">DESCRIÇÃO</p>
              </div>
              <div class="w-3/12 subtitle">
                <p>TIPO</p>
              </div>
              <div class="w-4/12 subtitle">
                <p>Franquia</p>
              </div>
            </div>
            <div class="flex flex-col gap-3 pt-4">
              <div
                v-for="servico in servicos"
                :key="servico.id_produto"
                class="flex w-full gap-2"
              >
                <div class="cell w-5/12 uppercase">
                  <p>{{ servico.descricao }}</p>
                </div>
                <div class="cell w-3/12">
                  <p>
                    {{ servico.tipo }}
                  </p>
                </div>
                <div class="cell w-4/12">
                  <p class="uppercase">
                    {{ servico.franquia }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </vx-card>

        <!-- SERVICOS CONTRATADOS MOBILE -->
        <vx-card class="mt-2 md:hidden">
          <div class="flex flex-col w-full">
            <div class="flex w-full title justify-center">
              <p>SERVIÇOS CONTRATADOS</p>
            </div>

            <div class="flex flex-col gap-3 pt-4">
              <div
                v-for="servico in servicos"
                :key="servico.id_produto"
                class="flex flex-col w-full gap-1"
              >
                <div class="flex w-full gap-2 mt-4">
                  <div class="w-full subtitle">
                    <p class="text-center pl-4">DESCRIÇÃO</p>
                  </div>
                </div>
                <div class="flex w-full gap-2 mt-4">
                  <div class="cell w-full uppercase">
                    <p>{{ servico.descricao }}</p>
                  </div>
                </div>
                <div class="flex w-full gap-2 mt-4">
                  <div class="w-full subtitle">
                    <p class="text-center pl-4">TIPO</p>
                  </div>
                </div>
                <div class="flex w-full gap-2 mt-4">
                  <div class="cell w-full uppercase">
                    <p>{{ servico.tipo }}</p>
                  </div>
                </div>
                <div class="flex w-full gap-2 mt-4">
                  <div class="w-full subtitle">
                    <p class="text-center pl-4">FRANQUIA</p>
                  </div>
                </div>
                <div class="flex w-full gap-2 mt-4">
                  <div class="cell w-full uppercase">
                    <p>{{ servico.franquia }}</p>
                  </div>
                </div>
                <div class="linha-divisor mt-6" />
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <div class="bodyGeral container relative content page">
      <div class="flex flex-col gap-4 mx-4 mt-4 md:mx-0">
        <div class="printBackground" />

        <vx-card class="mt-0">
          <div class="flex flex-col w-full">
            <div class="flex w-full title justify-center py-1">
              <p>Forma de pagamento</p>
            </div>
            <div class="flex flex-col gap-3 pt-4">
              <div class="flex flex-col md:flex-row w-full gap-2">
                <div class="cell w-full md:w-5/12">
                  <span>Periodicidade de pagamento:</span>
                  <p>Faturamento Mensal</p>
                </div>
                <div class="cell w-full md:w-4/12">
                  <span>Faturamento Mensal:</span>
                  <p>Boleto</p>
                </div>
                <div class="cell w-full md:w-3/12">
                  <span>Vencimento Mensal:</span>
                  <p class="uppercase">Dia {{ dadosVeiculo.diaVencimento }}</p>
                </div>
              </div>
            </div>
          </div>
        </vx-card>

        <vx-card class="mt-0">
          <div class="flex flex-col w-full">
            <div class="flex w-full title justify-center">
              <p>DADOS DO ESTIPULANTE</p>
            </div>
            <div class="flex flex-col gap-3 pt-4">
              <div class="flex flex-col md:flex-row w-full gap-2">
                <div class="cell w-full md:w-2/3">
                  <span>Nome/Nome Social:</span>
                  <p>{{ dadosVeiculo.estipulante }}</p>
                </div>
                <div class="cell w-full md:w-1/3">
                  <span>CPF/CNPJ:</span>
                  <p>{{ dadosVeiculo.cnpjEstipulante }}</p>
                </div>
              </div>

              <div class="flex flex-col md:flex-row w-full gap-2">
                <div class="cell w-full md:w-2/3">
                  <span>Endereço:</span>
                  <p>{{ getEnderecoEstipulanteParte('endereco') }}</p>
                </div>
                <div class="flex flex-col md:flex-row gap-2 w-full md:w-1/3">
                  <div class="cell w-full md:w-1/3">
                    <span>N°:</span>
                    <p>{{ getEnderecoEstipulanteParte('numero') }}</p>
                  </div>
                  <div class="cell w-full md:w-2/3">
                    <span>Telefone:</span>
                    <p>{{ dadosVeiculo.telefoneEstipulante }}</p>
                  </div>
                </div>
              </div>

              <div class="flex flex-col md:flex-row w-full gap-2">
                <div class="flex flex-col md:flex-row gap-2 w-full md:w-2/3">
                  <div class="cell w-full md:w-3/5">
                    <span>Bairro:</span>
                    <p>{{ getEnderecoEstipulanteParte('bairro') }}</p>
                  </div>
                  <div class="cell w-full md:w-2/5">
                    <span>Cidade:</span>
                    <p>{{ getEnderecoEstipulanteParte('cidade') }}</p>
                  </div>
                </div>
                <div class="flex flex-col md:flex-row gap-2 w-full md:w-1/3">
                  <div class="cell w-full md:w-3/4">
                    <span>CEP:</span>
                    <p>{{ getEnderecoEstipulanteParte('cep') }}</p>
                  </div>
                  <div class="cell w-full md:w-1/4">
                    <span>UF:</span>
                    <p>{{ getEnderecoEstipulanteParte('estado') }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </vx-card>

        <vx-card class="mt-0">
          <div class="flex flex-col w-full">
            <div class="flex w-full title justify-center">
              <p>CONDIÇÕES DO CONTRATO</p>
            </div>
            <div class="flex flex-col gap-4 pt-2 md:pt-6">
              <span
                class="text-justify text-sm md:text-base leading-tight contractText"
              >
                Declaramos que a empresa acima mencionada mantém junto a BP
                Seguradora S/A, apólices de RCV (Responsabilidade Civil de
                Veículos), Casco e APM, com vigência das 24hrs de
                {{ formataData(dadosVeiculo.dataAdesaoReal) }}
                até o período em que estiver ativo junto a estipulante
                {{ dadosVeiculo.estipulante }}, que intermedia a relação com a
                Companhia de Seguros, desde que cumpridas as cláusulas
                contratuais.
              </span>
              <span
                class="text-justify text-sm md:text-base leading-tight contractText"
                >Para veículos de leilão, chassi remarcado, táxi ou algum tipo
                de beneficio de compra, a cobertura do risco é sobre 70% do
                valor da FIPE.</span
              >
              <span
                class="text-justify text-sm md:text-base leading-tight font-semibold contractText"
                >Este certificado tem validade de 30 dias, contados a partir da
                data de vencimento da última mensalidade paga.</span
              >
            </div>
            <div class="flex flex-col gap-3 pt-4">
              <span class="text-base md:text-xl cityText font-semibold">
                Belo Horizonte, {{ formataData(new Date()) }}
              </span>
            </div>
            <div class="block h-48 md:hidden"></div>
            <div
              class="flex flex-col items-center uppercase cityText relative signatureMargin"
            >
              <div class="linha-assinatura flex justify-center relative">
                <img
                  src="../../../public/Assinatura_Fabio_Vasconcelos.png"
                  class="signature absolute"
                />
              </div>
              <span class="text-xl font-semibold mt-4">FÁBIO VASCONCELOS</span>
              <span class="text-base font-medium">DIRETOR</span>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <div class="rodape footer bg-header mt-12">
      <div class="container flex items-center">
        <div
          class="w-full gap-3 md:gap-0 flex flex-col md:flex-row justify-between py-3"
        >
          <div
            class="flex flex-col gap-3 md:gap-1 leading-tight text-black items-start tracking-tight"
          >
            <p class="tracking-tight">
              <span class="font-black">{{
                dadosVeiculo.nomeSeguradoraApolice
              }}</span>
              - CNPJ {{ dadosVeiculo.cnpjApolice }}
            </p>
            <span class="font-medium">{{ dadosVeiculo.telefoneApolice }}</span>
            <span class="font-medium">{{ dadosVeiculo.enderecoApolice }}</span>
          </div>
          <div
            class="flex flex-col gap-3 md:gap-1 leading-tight text-black items-start md:items-end w-full md:w-2/5 md:border-left"
          >
            <span class="font-black">www.bpseguradora.com.br</span>
            <span class="font-medium tracking-tight">
              Código de registro SUSEP 01546
            </span>
            <h5 class="text-start md:text-center tracking-tight">
              A <span class="font-black">BP</span> acompanha
              <span class="font-black">você</span> em todos os
              <span class="font-black">momentos</span>.
            </h5>
          </div>
        </div>
      </div>
    </div>

    <div class="flex flex-col items-end no-print">
      <div class="flex justify-end">
        <vs-button
          color="success"
          type="gradient"
          class="w-2/6 btn-print mt-5"
          @click="imprimePDF()"
        >
          Imprimir / Exportar PDF
        </vs-button>
      </div>
      <p class="italic text-sm pr-2 pt-2 text-right btn-print">
        Para melhor formatação do certificado <br />
        ao imprimir, utilizar a configuração de
        <br />
        margem mínima e ativar a opção <br />
        Gráficos de segundo plano no seu navegador
      </p>
    </div>
  </div>
</template>

<script>
import service from '../../services';
import locale from './../../locale';
import VxCard from '../../components/vx-card/VxCard.vue';
import { CERTIFICADO } from '../../commons/constant/certificadoCeguradora';
import { APOLICE } from '../../commons/constant/apolices';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export default {
  data() {
    return {
      dadosVeiculo: null,
      textoContrato: '',
      numeroApolice: null,
      numeroApolicePadrao: null,
      numeroCertificado: null,
      servicos: null,
      codTipoVeiculoMotos: 2,
    };
  },
  computed: {
    enderecoCompleto() {
      const { endereco, numero, complemento, bairro, cidade, estado, cep } =
        this.dadosVeiculo;
      return `${endereco}, ${numero} - ${complemento} ${bairro} - ${cidade} - ${estado} / ${cep}`;
    },

    filteredProdutos() {
      return this.dadosVeiculo.produtos.filter((produto) =>
        produto.nomeProduto.startsWith('RCF'),
      );
    },
    filteredProductsApp() {
      return this.dadosVeiculo.produtos.filter(
        (produto) =>
          produto.nomeProduto.startsWith('APP') ||
          produto.nomeProduto.startsWith('APM'),
      );
    },
    quantidadeRCF() {
      return this.dadosVeiculo.produtos.filter((produto) =>
        produto.nomeProduto.startsWith('RCF'),
      ).length;
    },
    rodapeRCFClass() {
      return [
        'rodape',
        'rodapePrint',
        'bg-header',
        `rodapeWith${this.quantidadeRCF}RCF`,
      ];
    },
  },
  methods: {
    imprimePDF() {
      window.print();
    },
    extractValor(nomeProduto) {
      const match = nomeProduto.match(/R\$ ?(\d{1,3}(?:\.\d{3})*),(\d{2})/);
      return match ? `${match[1]},${match[2]}` : '';
    },
    formatarMoeda(valor) {
      if (!valor) {
        return '0,00';
      }

      if (isNaN(valor)) {
        return valor;
      }
      const valorMonetario = valor.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        currencyDisplay: 'name',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      const valorSemSimbolo = valorMonetario.replace(/[^\d.,]/g, '').trim();
      return valorSemSimbolo;
    },
    formatarNomeRCF(nomeProduto) {
      const palavras = nomeProduto.trim().split(/\s+/);
      return palavras.slice(0, 4).join(' ');
    },
    checkNomeGrupo(grupo) {
      const regex = /^Furto \/ Roubo - /;
      if (!regex.test(grupo)) {
        return 'Seguro Completo';
      }
      return grupo;
    },
    getEnderecoCorretoraParte(chave) {
      const [endereco, numero, complemento, bairro, cep, cidade, estado] =
        this.dadosVeiculo.enderecoCorretora.split(' - ');
      const partes = {
        endereco,
        numero,
        complemento,
        bairro,
        cep,
        cidade,
        estado,
      };
      return partes[chave] || '-';
    },
    getEnderecoEstipulanteParte(chave) {
      const [endereco, numero, complemento, bairro, cep, cidade, estado] =
        this.dadosVeiculo.enderecoEstipulante.split(' - ');
      const partes = {
        endereco,
        numero,
        complemento,
        bairro,
        cep,
        cidade,
        estado,
      };
      return partes[chave] || '-';
    },
    getEnderecoSeguradoraParte(chave) {
      const [endereco, numero, complemento, bairro, cep, cidade, estado] =
        this.dadosVeiculo.enderecoApolice.split(' - ');
      const partes = {
        endereco,
        numero,
        complemento,
        bairro,
        cep,
        cidade,
        estado,
      };
      return partes[chave] || '-';
    },
    async downloadBoleto() {
      // Não está sendo usado, download de boleto usando puppeteer
      try {
        this.$vs.loading();

        const domain = `${window.location.protocol}//${
          window.location.hostname
        }${window.location.port ? ':' + window.location.port : ''}`;

        const username = this.$route.query.nome;
        const cpfUser = this.$route.query.cpf;
        const vehiclePlate = this.$route.query.placa;

        const idEmpresa = 118;

        const link = document.createElement('a');
        const result = await service.post(
          'CotacaoAberta',
          'geraPdfCertificado',
          {
            link: `${domain}/certificadoSeguradora?nome=${username}&cpf=${cpfUser}&placa=${vehiclePlate}`,
            idEmpresa,
          },
        );
        if (result.data) {
          link.href = result.data;
          link.setAttribute('download', 'certificado-seguro.pdf');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.$vs.loading.close();
        }
      } catch (error) {
        this.$vs.loading.close();
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: error,
          color: 'danger',
        });
      }
    },
    formataData(data) {
      const dataFormatada = dayjs.utc(data).format('DD/MM/YYYY');
      return dataFormatada;
    },
    somaValorTotalValoresAvista(arr1) {
      var total = 0;
      if (arr1 && arr1.length > 0)
        arr1.forEach((element) => {
          if (element.isMensal != true) total = total + element.valorFinal;
        });
      return total;
    },
    somaValorTotalMensal(arr1) {
      var total = 0;
      if (arr1 && arr1.length > 0)
        arr1.forEach((element) => {
          if (element.isMensal == true) total = total + element.valorFinal;
        });
      return total;
    },
    validateData(objSend) {
      const errors = [];

      objSend.chassi = objSend.chassi ? objSend.chassi.replace('@', '') : '';

      if (!objSend.chassi || objSend.chassi.length !== 17) {
        errors.push('O chassi deve ter pelo menos 17 caracteres.');
      }

      if (!objSend.isZero) {
        const placaRegex = /^[A-Z]{3}-\d[A-Z0-9]\d{2}$/i;
        if (!placaRegex.test(objSend.placa)) {
          errors.push('A placa deve estar no formato AAA-9*99.');
        }
      }

      if (!objSend.nome || objSend.nome.length < 3) {
        errors.push('O nome deve ter pelo menos 3 caracteres.');
      }

      if (
        !objSend.cpf ||
        (objSend.cpf.length !== 11 && objSend.cpf.length !== 14)
      ) {
        errors.push(
          'O CPF deve ter 11 caracteres e se for um CNPJ, deve ter 14 caracteres.',
        );
      }

      if (errors.length > 0) {
        return errors;
      }

      return false;
    },
    async buscaDados() {
      document.title = 'Certificado - BP Seguradora';
      this.isInterno = this.$route.query.interno;

      const STATUS_NO_CREATED = 204;

      const isZero = this.$route.query.isZero === 'true' ? true : false;
      const placa = isZero ? null : this.$route.query.placa;

      const objSend = {
        chassi: this.$route.query.chassi,
        cpf: this.$route.query.cpf,
        data: this.$route.query.data,
        placa: placa,
        isZero: isZero,
        nome: this.$route.query.nome,
      };

      const testReturn = this.validateData(objSend);

      if (testReturn) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `Dados inválidos.<br>${testReturn.join('<br>')}`,
          color: 'danger',
        });
        return;
      }

      try {
        this.$vs.loading();
        const response = await service.post(
          'CotacaoAberta',
          'buscaDadosCertificado',
          objSend,
        );

        if (response.status === STATUS_NO_CREATED) {
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Dados do beneficiário não encontrados em nosso sistema. Verifique se os dados foram digitados corretamente ou entre em contato com nossa central.',
            color: 'danger',
          });
          return;
        }

        const { data } = response;

        this.dadosVeiculo = data;
        this.defineNumeroApolicePadrao(this.dadosVeiculo);
        this.defineNumeroApoliceFinal(this.dadosVeiculo);
        this.defineServicos(this.dadosVeiculo.produtos);
        this.defineNumeroCertificado(this.dadosVeiculo.numeroCertificado);
        await this.validCorretora(this.dadosVeiculo.idRegional);
        this.$vs.notify({
          position: 'top-center',
          title: 'Sucesso',
          text: 'Certificado emitido com sucesso.',
          color: 'success',
        });
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Falha ao buscar certificado. Por favor, tente novamente.',
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async getRegional(idRegional) {
      const { data } = await service.post(
        'RegionalAberta',
        `find/${idRegional}`,
        {},
      );
      return data;
    },
    async validCorretora(idRegional) {
      const data = await this.getRegional(idRegional);
      if (data.corretoraRegional && data.corretoraAtiva && !data.deletedAt) {
        this.dadosVeiculo.corretora = data.nomeCorretora;
        this.dadosVeiculo.cnpjCorretora = data.documentCorretora;
        this.dadosVeiculo.codSusepCorretora = data.codigoSUSEP;
        this.dadosVeiculo.telefoneCorretora = data.telefoneCorretora;
        this.dadosVeiculo.emailCorretora = data.emailCorretora;
        this.dadosVeiculo.enderecoCorretora = `${data.enderecoCorretora} - ${data.numeroEnderecoCorretora} - ${data.complementoCorretora} - ${data.bairroCorretora} - ${data.cepCorretora} - ${data.cidadeCorretora} - ${data.estadoCorretora}`;
      }
    },
    defineNumeroCertificado(numeroCertificado) {
      const stringNumber = String(numeroCertificado);
      const newNumber = stringNumber.padStart(13, '0');
      this.numeroCertificado = `${newNumber.slice(0, 3)}.${newNumber.slice(
        3,
        4,
      )}.${newNumber.slice(4, 6)}.${newNumber.slice(6, 12)}.${newNumber.slice(
        12,
        13,
      )}`;
    },
    defineNumeroApolicePadrao(dadosVeiculo) {
      const { id_empresa } = dadosVeiculo;
      this.numeroApolicePadrao = CERTIFICADO.getCertificado(id_empresa);
    },
    defineNumeroApoliceFinal(dadosVeiculo) {
      if (dadosVeiculo.apoliceFixa === 1) {
        this.numeroApolice = dadosVeiculo.numeroApoliceCorretora;
        return;
      }
      if (dadosVeiculo.numeroApoliceRegional) {
        this.numeroApolice = dadosVeiculo.numeroApoliceRegional;
        return;
      }
      if (dadosVeiculo.numeroApoliceFipe) {
        this.numeroApolice = `${this.numeroApolicePadrao} / ${dadosVeiculo.numeroApoliceFipe}`;
        return;
      }
      this.numeroApolice = this.numeroApolicePadrao;
    },
    defineServicos(produtos) {
      const trechos = [
        'Assistência 24',
        'Vidros',
        'Carro reserva ',
        'Rastreador',
        'Rastreamento',
        'App Morte e Invalidez',
        'APP',
      ];

      const produtosFiltrados = trechos
        .map((trecho) => {
          const produtoEncontrado = produtos.find((produto) =>
            produto.nomeProduto.includes(trecho),
          );
          if (!produtoEncontrado) return null;
          if (trecho === 'Assistência 24') {
            return {
              descricao: produtoEncontrado.nomeProdutoResumo,
              tipo: produtoEncontrado.nomeProduto
                .replace('Assistência 24 horas ', '')
                .trim(),
              franquia: 'Não possui',
            };
          }
          if (trecho === 'Vidros') {
            return {
              descricao: produtoEncontrado.nomeProdutoResumo,
              tipo: 'Tipo Completo',
              franquia: '40% do Valor total',
            };
          }
          if (trecho === 'App Morte e Invalidez') {
            return {
              descricao: produtoEncontrado.nomeProdutoResumo,
              tipo: 'App',
              franquia: 'Não possui',
            };
          }
          if (produtoEncontrado.nomeProduto.startsWith('APP')) {
            return {
              descricao: produtoEncontrado.nomeProduto,
              tipo: '-',
              franquia: 'Não possui',
            };
          }
          if (trecho === 'Carro reserva ') {
            return {
              descricao: produtoEncontrado.nomeProdutoResumo,
              tipo: produtoEncontrado.nomeProdutoResumo
                .replace('Carro reserva ', '')
                .trim(),
              franquia: 'Não possui',
            };
          }
          if (trecho === 'Rastreador' || trecho === 'Rastreamento') {
            return {
              descricao: produtoEncontrado.nomeProdutoResumo,
              tipo: produtoEncontrado.nomeProdutoResumo,
              franquia: 'Não possui',
            };
          }
          return {
            descricao: produtoEncontrado.nomeProdutoResumo,
            tipo: produtoEncontrado.nomeProduto,
            franquia: produtoEncontrado.valor,
          };
        })
        .filter((item) => item);
      this.servicos = produtosFiltrados;
    },
    somaValorProdutoMensal() {
      const total = this.dadosVeiculo.produtos
        .filter((produto) => produto.isMensal)
        .reduce((acc, produto) => acc + produto.valor, 0);
      const valorTotalMensal = this.formatarMoeda(total);
      return valorTotalMensal;
    },
    isRcfAndCoopemetro(product) {
      const startsWithRCF = product.startsWith('RCF');
      const isCoopmetro = this.numeroApolice.includes(APOLICE.COOPMETRO);
      return startsWithRCF && isCoopmetro;
    },
    temAPP() {
      if (!this.dadosVeiculo.produtos) {
        return false;
      }
      const produtosApp = this.dadosVeiculo.produtos.filter((produto) =>
        produto.nomeProduto.startsWith('APM -'),
      );
      return produtosApp.length > 0;
    },
    hasProduct4021or5210(data) {
      return data.produtos.some(
        (produto) => produto.id_produto === 4021 || produto.id_produto === 5210,
      );
    },
  },
  mounted() {},
  created() {
    this.buscaDados();
    this.$validator.localize('ptBr', locale);
  },
  components: { VxCard },
};
</script>

<style lang="scss">
@import url('https://fonts.cdnfonts.com/css/gotham');

.marginOutside {
  padding: 16px 0;
}

body {
  background: #fff;
  justify-content: center;

  color: #000;
  font-size: 12px;
}

.bodyGeral {
  background-image: url('https://bboneapp.s3.amazonaws.com/bg-certificado.jpeg');
  background-repeat: no-repeat;
  background-position: 50%;
  padding: 0px 0;
  background-size: 50%;
}

.bg-header {
  background-color: #bcbebe;
  border-radius: 10px;
  height: 100px;
}

.cell {
  border: 2px solid #2ac4ee;
  border-radius: 4px;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-weight: 600;

  span {
    font-size: 0.85rem;
    color: #0a5186;
  }
  p {
    text-transform: uppercase;
    padding-top: 4px;
    color: #000d37;
    font-size: 1rem;
    overflow-wrap: break-word;
  }
}

.title {
  background-color: #000d37 !important;
  color: white;
  border-radius: 4px;
  padding: 4px 0;

  p {
    text-align: center;
    text-transform: uppercase;
    font-weight: 500;
    font-size: 1.25rem;
  }
}

.subtitle {
  background: #000d37 !important;
  print-color-adjust: exact;
  color: white;
  border-radius: 4px;
  padding: 4px 0;

  p {
    text-align: center;
    text-transform: uppercase;
    font-weight: 500;
    font-size: 12px;
  }
}

.cabecalhoPdf {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 1rem 1rem 0 1rem;
  padding: 1.5rem 1rem;
}

.rodape {
  display: none;
  background-color: #bcbebe;
  border-radius: 16px;
  color: #fff;
  padding: 5px;

  p,
  h5,
  span {
    font-size: 14px;
  }
}

.signature {
  width: 160px;
  margin-top: -140px;
}

@media (min-width: 768px) {
  .signatureMargin {
    margin-top: 200px;
  }

  .signature {
    margin-top: -190px;
    width: 240px;
  }

  .cell {
    flex-direction: row;
    gap: 0.5rem;

    span {
      font-size: 1rem;
    }
    p {
      font-size: 1.125rem;
    }
  }

  .title {
    background-color: #000d37 !important;
    color: white;
    border-radius: 4px;
    padding: 4px 0;

    p {
      text-align: center;
      text-transform: uppercase;
      font-weight: 500;
      font-size: 24px;
    }
  }

  .subtitle {
    background: #000d37 !important;
    print-color-adjust: exact;
    color: white;
    border-radius: 4px;
    padding: 4px 0;

    p {
      text-align: center;
      text-transform: uppercase;
      font-weight: 500;
      font-size: 16px;
    }
  }

  .cabecalhoPdf {
    display: flex;
    margin: 0;
    padding: 1rem 2rem;
  }

  .rodape {
    display: flex;
    background-color: #bcbebe;
    border-radius: 16px;
    color: #fff;
    padding: 5px;

    p,
    h5,
    span {
      font-size: 18px;
    }
  }
}

.contractText {
  font-size: 16px;
  color: #1a2a55;
}

.cityText {
  color: #0a5186;
}

.linha-assinatura {
  width: 50%;
  margin: 0 auto;
  border-bottom: 2px solid #14beed;
  margin-top: 20px;
}

.linha-divisor {
  width: 100%;
  margin: 0 auto;
  border-bottom: 1px solid #000d37;
  margin-top: 0px;
}

.wrapperPage {
  font-family: 'regular', 'Montserrat', sans-serif;
  text-rendering: optimizeLegibility !important;
  -webkit-font-smoothing: antialiased !important;
}

.tracking-tight {
  letter-spacing: -0.05em;
}

.border-left {
  border-left: 2px solid rgba(255, 255, 255, 0.5);
}

.vx-card {
  background-color: transparent !important;
  box-shadow: none !important;
  border-radius: 0px;

  .vx-card__body {
    padding: 0px !important;
    margin: 0;
  }
}

.boxCobertura {
  min-height: 300px;
  border: 0;
}

.A3 .sheet {
  width: 297mm;
  height: 419mm;
}

.A3.landscape .sheet {
  width: 420mm;
  height: 296mm;
}
.A4 .sheet {
  width: 210mm;
  height: 296mm;
}
.A4.landscape .sheet {
  width: 297mm;
  height: 209mm;
}
.A5 .sheet {
  width: 148mm;
  height: 209mm;
}
.A5.landscape .sheet {
  width: 210mm;
  height: 147mm;
}

/** Padding area **/
.sheet.padding-10mm {
  padding: 10mm;
}
.sheet.padding-15mm {
  padding: 15mm;
}
.sheet.padding-20mm {
  padding: 20mm;
}
.sheet.padding-25mm {
  padding: 25mm;
}

/** Fix for Chrome issue #273306 **/
@media print {
  .A3.landscape {
    width: 420mm;
  }
  .A3,
  .A4.landscape {
    width: 297mm;
  }
  .A4,
  .A5.landscape {
    width: 210mm;
  }
  .A5 {
    width: 148mm;
  }
}
@media screen {
  .printer {
    display: none;
  }
}
@media print {
  @page {
    margin: 1cm;
  }
  body {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  .marginOutside {
    padding: 0;
    margin: 0;
  }

  .printBackground {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 100vh;
    z-index: -1;
    background-image: url('https://bboneapp.s3.amazonaws.com/bg-certificado.jpeg');
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: 50%;
  }

  .vx-card {
    background-color: transparent !important;
    box-shadow: none !important;
    border-radius: 0px;
    page-break-inside: avoid;

    .vx-card__body {
      padding: 0px !important;
      margin: 0;
    }
  }

  .bodyGeral {
    background: transparent;
  }

  .bg-header {
    background: #bcbebe;
    border-radius: 10px;
    print-color-adjust: exact;
  }

  .cell {
    border: 2px solid #2ac4ee;
    border-radius: 4px;
    padding: 0.5rem;
    display: flex;
    gap: 0.5rem;
    font-weight: 600;

    span {
      font-size: 0.625rem;
      color: #0a5186;
    }
    p {
      text-transform: uppercase;
      padding-top: 4px;
      font-size: 0.8rem;
    }
  }

  .title {
    background: #000d37 !important;
    print-color-adjust: exact;
    color: white;
    border-radius: 4px;
    padding: 4px 0;

    p {
      text-align: center;
      text-transform: uppercase;
      font-weight: 500;
      font-size: 20px;
    }
  }

  .subtitle {
    background: #000d37 !important;
    print-color-adjust: exact;
    color: white;
    border-radius: 4px;
    padding: 4px 0;

    p {
      text-align: center;
      text-transform: uppercase;
      font-weight: 500;
      font-size: 16px;
    }
  }

  .contractText {
    font-size: 16px;
    color: #1a2a55;
  }

  .cityText {
    color: #0a5186;
  }

  .linha-assinatura {
    width: 50%;
    margin: 0 auto;
    border-bottom: 2px solid #14beed;
    margin-top: 20px;
  }
  .signature {
    margin-bottom: -90px;
    width: 220px;
  }

  .rodape {
    p,
    h5,
    span {
      font-size: 12px;
    }
  }

  .wrapperPage {
    font-family: 'regular', 'Montserrat', sans-serif;
    text-rendering: optimizeLegibility !important;
    -webkit-font-smoothing: antialiased !important;
  }

  .tracking-tight {
    letter-spacing: -0.05em;
  }

  .border-left {
    border-left: 2px solid rgba(255, 255, 255, 0.5);
  }

  .btn-print {
    display: none;
  }

  .header {
    position: fixed;
    top: 4px;
    left: 16px;
    right: 16px;
    height: 100px;
  }

  .footer {
    position: fixed;
    bottom: 4px;
    left: 16px;
    right: 16px;
    height: 100px;
  }
  .content {
    margin: 110px 10px 110px;
    page-break-inside: avoid;
  }
  .no-print {
    display: none;
  }
  .page {
    page-break-after: always;
  }
}
</style>
